<div class="" >
  <ng-multiselect-dropdown
    [placeholder]="'Select Preferences'"
    [ngModel]="localSelectedEventActions"
    [data]="eventActionsOptions"
    [settings]="dropdownSettings"
    (onSelect)="onManualSelect($event)"
    (onDeSelect)="onManualDeSelect($event)"
    (onSelectAll)="onManualSelectAll($event)"
    (onDeSelectAll)="onManualDeSelectAll()">
  </ng-multiselect-dropdown>
</div>
